<!-- 活动页专用布局：全宽、无 PC 最小宽度限制，适配手机 -->
<template>
  <div class="event-mobile-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'EventMobileLayout'
}
</script>

<style lang="less" scoped>
.event-mobile-container {
  width: 100%;
  max-width: 100vw;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0;
  overflow-x: hidden;
  box-sizing: border-box;
}
</style>
